export default __webpack_public_path__ + "static/media/escritorioipiranga.d6897a5c.jpg";